module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('group', [_c('cell', {
    attrs: {
      "value-align": "left"
    }
  }, [_c('div', {
    staticStyle: {
      "color": "#4f5b77"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.cuIndex) + " "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.multichoice.subjectName)
    }
  }), _vm._v(" "), _c('span', [(_vm.multichoice.score !== '' && _vm.multichoice.score !== undefined && _vm.multichoice.score !== 0) ? _c('span', {}, [_vm._v("(" + _vm._s(_vm.multichoice.score) + "分)")]) : _vm._e()])])])], 1), _vm._v(" "), _c('checklistspec', {
    ref: _vm.multichoice.id,
    attrs: {
      "mchoice": true,
      "options": _vm.options
    },
    on: {
      "on-change": _vm.toggleOption
    },
    model: {
      value: (_vm.anwser),
      callback: function($$v) {
        _vm.anwser = $$v
      },
      expression: "anwser"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-188a3c82","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subjects/MultipleChoices/index.vue
// module id = 668P
// module chunks = 6